<template>
  <div>
    <nav class="global-nav drawer-nav" role="navigation"><div class="global-nav-container">
  <ul class="global-nav-list">
    <li class="global-nav-list-item global-nav-mypage">
      <router-link to="/account">
        <div class="image"> <img :src="`@/${getIcoMenuMypagePath()}`" alt="" /></div>
        <div style="display: flex; flex-direction: column;">
          <div>【アカウント情報】</div>
          <div><i class="user-name">{{this.getMyPageNameFromUserSession()}}<br>{{ getMyPageLoginIdFromUserSession() }}</i></div>
        </div>        
      </router-link>
    </li>
    
    <div class="global-nav-selected-clinic">
      <div class="image"><img :src="`@/${getImgSelectedClinic()}`" alt="" /></div>      
      <div class="sidebar-selected-clinic-name" v-if="this.clinicInfo">
        <div>＜選択中の施設名＞</div>
        <a v-on:click="showSelectClinicModal">
          <div><i>{{this.clinicInfo.name}}</i></div>
        </a>          
      </div>        
    </div>    
    
    <li class="global-nav-list-item global-nav-product">
      <div class="global-nav-product-toggle">各種ご注文</div>
      <ul class="global-nav-product-list">
        <li v-if="showOrderFunction(clinicInfo)" class="global-nav-product-list-item">
           <a v-on:click="startOrder()">
              <div >ご注文フォーム</div>                
            </a>
        </li>
        <li class="global-nav-product-list-item">
           <router-link to="/orderhistory">
              <div>ご注文履歴</div>
           </router-link>
        </li>
      </ul>      
    </li>
    
    <li class="global-nav-list-item global-nav-others">
      <router-link to="/practiceSupport">
         <div>{{ practiceSupportTitle }}</div>
      </router-link>
    </li>
    <li class="global-nav-list-item global-nav-others">
      <router-link to="/inspection">
         <div>点検依頼</div>
      </router-link>
    </li>
    <li class="global-nav-list-item global-nav-others">
      <router-link to="/servicereportlist">
        <div>サービスレポート 一覧</div>
      </router-link>
    </li>
    <li class="global-nav-list-item global-nav-others">
      <router-link to="/jlearninglist">
        <div>J-learning 一覧</div>
      </router-link>
    </li>      

    <li class="global-nav-list-item global-nav-product">
      <div class="global-nav-product-toggle">製品一覧</div>
      <ul class="global-nav-product-list">
        <li class="global-nav-product-list-item" v-for='item in this.getMachineList(machineList)' :key="item.name" v-on:click='toDetail(item.id, item.is_common)'>
           <a>
              <div class="image">
                <img :src='item.icon_path' alt="" />
              </div>
              <div>{{item.name}}</div>
            </a>
        </li>
      </ul>
    </li>
    
    <li class="global-nav-list-item global-nav-others">
      <router-link to="faq">
        <div>Ｑ＆Ａ</div>
      </router-link>
    </li>
    <li class="global-nav-list-item global-nav-others">
      <router-link to="/contact">
        <div>お問い合わせ</div>
      </router-link>
    </li>
    <li class="global-nav-list-item global-nav-others">
      <router-link to="/terms">
        <div>利用規約</div>
      </router-link>
    </li>
    <li class="global-nav-list-item global-nav-others">
      <a href="https://www.jmec.co.jp/privacy/">
        <div>個人情報保護方針<img class="external-link-icon" src="../../static/img//アイコン_外部リンク_エンジ.png" /></div>
      </a>      
    </li>
  </ul>
</div></nav><!--/.global-nav-->    

<OrderFormModal 
  :propsName="orderFormModalName"
  :propsDisplayItems="displayItems"  
  @selectOrderItem="selectedItem"  
  ref="order_form_modal" />  

  <SelectBillingUserModal 
  :propsName="selectBillingUserModalName" 
  :propsBillings="billingInfoList"
  :propsSelectedBilling="selectBullingInfo"
  @selectedBilling="selectedBilling"
  @callGoOrderForm="goOrderFormPage"  
  ref="select_billing_modal" />

  <SelectClinicModal 
  :propsName="selectClinicModalName"
  :propsClinics="clinicList"
  :propsSelectedClinic="clinicInfo"
  @selectedClinic="changeClinic"  
  ref="select_clinic_modal"
  />

    <!-- インジケーター -->
    <Indicator ref="indicator" />
  
  </div>    
</template>

<script>
import DeliveryMethods from '../mixins/delivery-methods'
import apiMixins from '../mixins/ApiUtil';
import authMixins from '../mixins/AuthUtil'
import cookieUtil from '../mixins/CookieUtil';
import s3Downloader from '../mixins/S3Downloader'
import OrderFormModal from '../components/OrderFormModal.vue'
import SelectBillingUserModal from './SelectBillingUserModal.vue';
import Indicator from './Indicator.vue';
import SelectClinicModal from './SelectClinicModal.vue';

export default {
  name: 'SideBar',
  mixins: [apiMixins, s3Downloader, cookieUtil, authMixins],
  components: {
    OrderFormModal,    
    SelectBillingUserModal,
    Indicator,
    SelectClinicModal
  },
  data () {
      return {
        practiceSupportTitle: DeliveryMethods.PRACTICE_SUPPORT_HEADER,
        clinicCode: '',
        machineList: [],
        orderFormModalName: "sidebar_order_form_modal",   
        selectBillingUserModalName: "sidebar_select_billing_user_modal",                  
        selectClinicModalName: "sidebar_select_clinic_modal",
        accountInfo: null,   // アカウント情報        
        billingInfoList: null,
        selectBullingInfo: null,
        displayItems: [],
        clinicInfo: null,
        clinicList: [],
        selectedItemType: null
      }
  },
  methods: {
    //#region API周り
    /**-------------------------------------------------- API ------------------------------------------ */     
    /**
     * 機種一覧取得要求を行う
     */
    requestModelList: async function () {    
      var queryStringParameters = {
        clinic_code: this.clinicCode,
        domain: DeliveryMethods.DOMAIN
      }

      const result = await this.requestModelListOfUserSite(queryStringParameters)

      if (result === null || result.data.data.length <= 0) {
        return
      }

      // アイコンパスからPresignedUrlを作成
      for (let i = 0; i < result.data.data.machines.length; i++) {
        const iconPath = result.data.data.machines[i].icon_path
        result.data.data.machines[i].icon_path = await this.createPresignedUrl(DeliveryMethods.BUCKET_NAME.ICON, 'machine/' + iconPath)
      }

      this.machineList = result.data.data.machines.map((item) => {
        return { ...item }
      })
      console.log('result: ', this.machineList)
    },
    /**
     * 請求先情報の取得を行う
    */
    requestBillings: async function () {   
      const userId = await this.getUserId();       
        var queryStringParameters = {
            user_id: userId,
            clinic_code: this.clinicCode
        }      
        const result = await this.requestGetBillingList(queryStringParameters);        
                    
        const detail = this.getResultOfGetBillingUser(result);

        if (detail.isSuccess) {
            this.billingInfoList = result.data.data.billings;
        }            
    },  
    /**
     * 特定クリニック情報の取得を行う
     */
      requestSpecificClinicInfo: async function () {
        const result = await this.requestGetClinic(this.clinicCode);

        if (result === null || result.data.data.length <= 0) {
            return;
        }

        this.clinicInfo = result.data.data;            
    },
    /**
     * ユーザーに紐づくクリニック情報の一覧の取得を行う 
     */
    requestClinicList: async function () {   
      const userId = await this.getUserId();          
      var queryStringParameters = {
        user_id: userId,
        domain: DeliveryMethods.DOMAIN
      }
      const result = await this.requestGetClinics(queryStringParameters);

      if (result === null || result.data.data.length <= 0) {
        return
      }
      
      this.clinicList = result.data.data.clinics.map((item) => {
        return { ...item }
      });      
      
      console.log('result: ', this.clinicList)      
    },
    /**------------------------------------------------------------------------------------------------- */     
    //#endregion
  

  //#region 請求先選択・商品種別選択モーダルの各種処理
  /**-----------------------------請求先選択・商品種別選択モーダルの各種処理------------------------------ */
  /**
   * 注文開始 商品種別選択       
   */
  startOrder: async function() {
    this.clear();

    // 請求先情報・出庫先情報の取得
    this.$refs.indicator.doAjax();                                
    await this.requestBillings();    
    this.$refs.indicator.onCancel();

    this.setOrderItem();
    this.showOrderFormModal();                
  },
  /**
   * 商品種別選択モーダルで選択された際に呼ばれる
   * @param selectedItemType 選択した商品の種別
   */
    selectedItem: async function (selectedItemType) { 
    this.hideOrderFormModal();           
    // 選択した商品種別を一時保管
    this.selectedItemType = selectedItemType;        

    if (this.billingInfoList && this.billingInfoList.length == 1) {
        // 請求先をCookieに保存して、注文フォームへ遷移する
        this.saveBillingOfCookie(this.billingInfoList[0]);
        this.goOrderFormPage();
    } else {
        // 請求先選択
        this.showSelectBillingModal();
    }                
  },
  /**
   * 表示する商品の設定を行う
  */
  setOrderItem () {                        
    var displayItems = [];
    // 一覧に変換
    displayItems = this.convertDisplayItemsToStringArray(this.clinicInfo.display_items);
    // 表示対象広告の設定
    this.displayItems = displayItems;            
  }, 
  /**
   * 請求先が選択された際に呼ばれる
   * 請求先の保存を行う
   * @param billing 選択された請求先
   */
  selectedBilling: async function(billing) {                        
    this.saveBillingOfCookie(billing);            
  }, 
  /**         
   * 選択中の請求ユーザーコードをCookieに保存する
   */
  saveBillingOfCookie (billingInfo) {            
    this.setBillingUserCodeToCookie(billingInfo.code);            
  }, 
  /**
   * クリニックを変更した際に呼ばれる
   * @param event 選択したクリニック情報
   */
   changeClinic: async function (clinic) {        
    this.hideSelectClinicModal();
    
    const clinicCode = clinic.code;
    // Cognitoのクリニックコードを更新
    await this.updateClinicCodeOfCognito(clinicCode);  
        
    if (this.$route.path === '/home') {
      // 画面更新
      window.location.reload(); 
    } else {
      this.$router.replace('/home');
    }    
  },
  /**------------------------------------------------------------------------------------------------- */
  //#endregion

  //#region 画面遷移周り
  /**---------------------------------------------- 画面遷移 ------------------------------------------ */       
  /**
   * 注文フォームへ遷移
   */
    goOrderFormPage () {
      this.$router.push({
          name: 'OrderForm',
          query: { type: this.selectedItemType }
      });
  },   
  /**------------------------------------------------------------------------------------------------- */                
  //#endregion

  //#region モーダル表示周り
  /**---------------------------------------------- モーダル表示 ------------------------------------------ */       
  showOrderFormModal () {        
      this.$refs.order_form_modal.show();
  },
  /**
   * 注文メニューのダイアログを閉じる
   */
  hideOrderFormModal() {
    this.$refs.order_form_modal.hide();
  }, 
    
  /**
   * 注文メニューのダイアログを表示
  */
  showOrderFormModal() {      
    this.$refs.order_form_modal.show();
  },
  /**
   * 注文メニューのダイアログを表示
  */
  showOrderFormModal() {            
      this.$refs.order_form_modal.show();
  },              
  /**
   * 請求先選択のダイアログを表示
  */
  showSelectBillingModal () {
    this.selectBullingInfo = null;
    this.$refs.select_billing_modal.show();
  },
  /**
   * 請求先選択ダイアログを閉じる
  */
  hideSelectBillingModal () {
      this.$refs.select_billing_modal.hide();            
  },
  showSelectClinicModal () {
    this.$refs.select_clinic_modal.show();
  },
  hideSelectClinicModal () {
    this.$refs.select_clinic_modal.hide();
  },
  /**----------------------------------------------------------------------------------------------------- */       
  //#endregion


  toDetail (machineId, isCommon) {
      if (!machineId || (isCommon !== 0 && isCommon !== 1)) {
          console.log('return')
          return
      }
      this.$router.push({
          name: 'Detail',
          params: { id: machineId, is_common: isCommon }
      })
  },               
    
  clear() {                
    this.accountInfo = null;
    this.billingInfoList = null;
  }
},
mounted: async function () {          
  this.clinicCode = await this.getClinicCodeForCognito();
  await this.requestModelList();  
  await this.requestSpecificClinicInfo();
  await this.requestClinicList();

  if (this.isLogin() && this.isAgreedTerms()) {
    // ドロワー
    $(function () {
      $('.drawer').drawer()
    })
  }  

  //  ファイルリスト
  $(function () {
    $('.global-nav-product-toggle').click(function () {
      $(this).toggleClass("active");
      $(this).next('.global-nav-product-list').slideToggle(200, function(){
        $('.drawer').scrollRefresh();
      });
    });
  });
}
}
</script>


// WEBPACK FOOTER //
// src/components/Sidebar.vue